export enum ApiKeyScope {
  NEXTORE_READ = 'nextore:read',
  NEXTORE_WRITE = 'nextore:write',
}

export enum ApiKeyEnvironment {
  LIVE = 'live',
  TEST = 'test',
}

export type ApiKeyDto = {
  id: string;
  keyId: string;
  keyPrefix: string;
  name: string;
  organizationId: string;
  environment: ApiKeyEnvironment;
  scopes: ApiKeyScope[];
  createdAt: string;
  createdByEmail: string | null;
  expiresAt: string | null;
  revokedAt: string | null;
  revokedByEmail: string | null;
  lastUsedAt: string | null;
  lastUsedIp: string | null;
};

export type ScopeDescription = {
  scope: ApiKeyScope;
  label: string;
  description: string;
};
